// src/components/Login.js
import React, { useContext, useEffect, useRef, useState, useMemo } from 'react';

import AuthInput from '../AuthUI/auth_Input';
import BasicTimeline from './BasicTimeLine';
import './AuthManager.css'
import { ManagerContext } from '../../contexts/ManagerContext';
import { Button } from '@mui/material'
import Login from '../Auth/login';
import CoffeeIcon from '@mui/icons-material/Coffee';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography'

import Badge, { badgeClasses } from '@mui/material/Badge';
import { Box } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import TimelineDot from '@mui/lab/TimelineDot';
import Snackbar, { SnackbarOrigin } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import PsychologyAltIcon from '@mui/icons-material/PsychologyAlt';
import CustomDrawer from '../CustomDrawer';
import { isMobile } from 'react-device-detect';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function AvatarChat() {
  // contexts
  const containerRef = useRef(null);
  const { currentUser, currentPage, urlType, urlServer, messagesRef, authFromServer, sendMessage, connectionState, setAuthSkill} = useContext(ManagerContext);
  // const { setUser, currentUser } = useAuth()
  const [ counter, setCounter ] = useState(0)
  const [ destination, setDestination ] = useState(0)
  const [ readed, setReaded ] = useState(1)
  const [ messages, setMessages ] = useState([])
  const [ indexMessage , setIndexMessage ] = useState(0)
  const [ imageUrl, setImageUrl ] = useState(null)
  const [ unreadedCount, setUnreadedCount ] = useState(0)
  const [ isAnimating, setIsAnimating ] = useState(false); // nowy stan do kontrolowania animacji
  const [ lastUrl, setLastUrl ] = useState();
  // useState
  const [mapData, setMapData] = useState(null);
  const [isTalking, setIsTalking] = useState(false);
  const [ waitForMessage, setWaitForMessage ] = useState(false);
  const [ isInit, setIsInit ] = useState(false);
  const [ _fontSize, setFontSize ] = useState('3vmax');  
  const [ full, setFull ] = useState('80vh');
  const [scrollValue, setScrollValue] = React.useState(0);
  const scrollStep = 450; // określona wartość skoku
  const [stateMind, setStateMind] = React.useState({
    open: false,
    vertical: 'top',
    horizontal: 'center',
    gold_mind: ''
  });
  const { vertical, horizontal, open, gold_mind } = stateMind;
  const [ isFadingOut, setIsFadingOut ] = useState(false);
  const markdownsRef = useRef([]);


  // Funkcja do oznaczania wiadomości jako przeczytanej
  const markAsRead = async (messageId) => {
    // Zaktualizuj lokalny stan na przeczytane
    const updatedMessages = messages.map(msg =>
      msg.id === messageId ? { ...msg, isRead: true } : msg
    );
    // setMessages(updatedMessages);

    // Wyślij zapytanie do serwera
    const response = await markMessageAsReadOnServer(messageId);
    
    if (response.ok) {
      // Zaktualizuj licznik nieprzeczytanych jeśli potwierdzenie od serwera
      setUnreadCount(prevCount => prevCount - 1);
    } else {
      // Ewentualne obsługę błędów
    }
  };

  React.useEffect(() => {
    console.log('get ref', messagesRef.current)
  } , [messagesRef])

  // // Funkcję do przewijania do ostatniej nieprzeczytanej wiadomości
  const scrollToLastUnread = () => {
    const lastUnread = messages.slice().reverse().find(msg => !msg.isRead);
    if (lastUnread) {
      scrollToPosition(counter + 1)
    }
  };

  const isFullScreen = () => {
    return document.fullscreenElement || 
           document.webkitFullscreenElement || // Safari
           document.mozFullScreenElement || // Firefox
           document.msFullscreenElement; // IE/Edge
}

// React.useEffect(() => {
//   console.log('fulscreen: ', isFullScreen())
//   if (!isFullScreen()){
//     setFull('100vh')
//   }else{
//     setFull('90vh')
//   }
// } , [])


  // Funkcja do zmiany obrazka
  const changeImage = (newImageUrl) => {
    setTimeout(() => {
      setImageUrl(newImageUrl); // Zmień obraz gdy ściemniony
      setIsFadingOut(false); // Rozjaśnić
    }, 500); // Czas dopasowany do czasu animacji fadeOut
  };

  const scrollToDirection = () => {
    if (containerRef.current) {
      setIsAnimating(true); // zablokuj przycisk
      // Ustal, gdzie chcemy, żeby scroll się skończył
      const start = counter * scrollStep;
      const duration = 100; // Czas animacji w milisekundach
      const end = destination * scrollStep;
      let startTime;
  
      const animateScroll = (timestamp) => {
        if (!startTime) startTime = timestamp;
        const elapsed = timestamp - startTime;
        const progress = Math.min(elapsed / duration, 1);
  
        const currentScroll = start + (end - start) * progress; // Interpolacja scrolla
        containerRef.current.scrollTop = currentScroll;
        if (progress < 1) {
          requestAnimationFrame(animateScroll);
        } else {
          // Ustaw ostateczny scroll na końcową pozycję
          containerRef.current.scrollTop = end;
  
          // Aktualizuj counter po zakończeniu animacji
          setCounter(destination);
          setReaded(prev => {
            setUnreadedCount(messages.length);
            return;
          });
  
          setIsAnimating(false); // odblokuj przycisk po zakończeniu animacji
        }
      };
  
      requestAnimationFrame(animateScroll);
    }
  };
  

    
  React.useEffect( () => {
    // console.log('destination: ', destination, 'counter: ', counter)
    const message = messages[destination]
    if(message && message.metadata && message.metadata.url_image){
      const image = new Image();
      
      // console.log('url',message.url_image)
      // const url = `https://my-fastapi-service-325267344341.europe-west4.run.app/${message.metadata.url_image}`
      const url = `${urlType===0?'http://':'https://'}${urlServer}${message.url_image}`
      image.src = url;
      
      setIsFadingOut(true); // Rozpocznij animację ściemniania
      image.onload = () => {
        // setImageUrl(`url(${image.src})`);
        changeImage(`url(${image.src})`);
      };
      scrollToDirection();
    }else{
      // console.log('brak url', message)
      setImageUrl(null)
      setIsFadingOut(true); // Rozpocznij animację ściemniania
    }
    if (destination!=counter) {
      if(message && message.golden_thought){
        setStateMind({ ...stateMind, open: true, gold_mind: message.golden_thought });
      } else {
        setStateMind({ ...stateMind, open: false });
      }
      scrollToDirection();
      
    }
  }, [destination, counter])

  React.useEffect( () => {
  messages.map((item, index, messages) => {
    const message = messages[destination]
    if(message && message.url_image){
      console.log('url',message.url_image)
      const image = new Image();
       // Rozpocznij animację ściemniania
      const url = `${urlType===0?'http://':'https://'}${urlServer}${message.url_image}`
      if (url !== lastUrl) {
        setIsFadingOut(true);
      }
      setLastUrl(url);
      image.src = url;
      // console.log('zaladowany', url)    
      image.onload = () => {
        // setImageUrl(`url(${image.src})`);
        changeImage(`url(${image.src})`);
      };
    }else{
      setImageUrl(null)
      setIsFadingOut(true); // Rozpocznij animację ściemniania
    }
    // if(message && message.golden_thought){
    //   setStateMind({ ...stateMind, open: true, gold_mind: message.golden_thought });
    // } else {
    //   setStateMind({ ...stateMind, open: false });
    // }    
  });
      
  }, [messages])

  const handleClick = (newState) => () => {
    setStateMind({ ...newState, open: true });
  };

  const handleClose = () => {
    setStateMind({ ...stateMind, open: false });
  };


  // Funkcja do deserializacji audio z JSON
  function deserializeAudioFromJson(audio) {
    // const data = JSON.parse(jsonData);
    const audioBase64 = audio;

    // Przekształcenie Base64 na binarne dane
    const audioBytes = Uint8Array.from(atob(audioBase64), c => c.charCodeAt(0));

    // Utworzenie obiektu Blob z danymi audio
    const audioBlob = new Blob([audioBytes], { type: 'audio/mp3' });
    const audioUrl = URL.createObjectURL(audioBlob);

    const audioElement = new Audio(audioUrl);
    audioElement.play();
  }

  useEffect( () => {
    if (containerRef.current) {
      containerRef.current.scrollTop = scrollValue;
    }
    const handleResize = () => {
      // const newFontSize = `${window.innerWidth / 130}px`;
      const newFontSize = '15px';
      setFontSize(newFontSize);
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Inicjalne ustawienie

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [] )

  useEffect(() => {
    console.log('main get message')
    // console.log('get data from serwer2: ', authFromServer, Date.now())
    if (authFromServer){
        const map = new Map(Object.entries(authFromServer))
        setMapData(map)
        if (map.has("init_massages")) {
          console.log('init messages: ', map.get("init_massages"))
          
          setDestination(map.get("init_massages").length-1)
          // setMessages(assistant_messages)
          setMessages(map.get("init_massages"))
          // setAssistantMessages(assistant_messages)
        } else
        if (map.has("new_message")) { 
          const new_message = map.get("new_message")
          setMessages(prevMessages => {
            // Sprawdź, czy nowa wiadomość już istnieje
            const messageIndex = prevMessages.findIndex(msg => msg.id === new_message.id);
            let updatedMessages;
        
            if (messageIndex !== -1) {
              // Jeśli wiadomość istnieje, zaktualizuj ją
              updatedMessages = prevMessages.map((msg, index) => {
                // Sprawdź, czy bieżący index to index istniejącej wiadomości
                if (index === messageIndex) {
                  // Debugowanie: Zobacz, jakie właściwości są aktualizowane

                  // gdy new_message zawiera content_delta dodaje ją do content
                  console.log('count: ', new_message.count, 'delta:', new_message.content_delta)
                  if (new_message.content_delta && new_message.content_delta !== undefined) {
                    return { ...msg, content: msg.content + new_message.content_delta };
                  }else{
                    return { ...msg, ...new_message };
                  }

                  }
                    return msg; // Pozostałe wiadomości pozostają bez zmian
                });
            } else {
              // Dodawanie nowej wiadomości jeśli istnieje rola asystenta
              console.log('Adding new message:', new_message);
                  updatedMessages = [...prevMessages, new_message];
                  if (prevMessages.length > 0) {
                      setDestination(prevMessages.length);
                  }
                // if (new_message.role === 'assistant') {
                    
                // } else {
                //     // Jeśli rola nie jest asystenta, zachowaj stare wiadomości
                //     updatedMessages = prevMessages;
                // }
            }
        
            // Debugowanie aktualnego stanu wiadomości
            // console.log('Updated messages:', updatedMessages);
            return updatedMessages;
        });
          setWaitForMessage(false)
        }

          if (map.has("audio")) { console.log( deserializeAudioFromJson( map.get("audio") ) ) }
        }
      
      
    
  }, [authFromServer]);

  useEffect(() =>{
    // console.log(connectionState, waitForMessage)
    if (connectionState != "OPEN" || waitForMessage) {
      setIsTalking(true)
    } else {
      setIsTalking(false)
    }
    if ( connectionState === "OPEN" ){
      if ( !isInit ) {
        sendTask("init")
      }
      setIsInit(true)
    }
  }, [connectionState, waitForMessage])

  const sendTask = (taskName, data ) => {
    const map = new Map();
    map.set("name", "authSkill");
    map.set("task", taskName );
    if (data) map.set("data", data)
    sendMessage(map);
  }

  const sendMessage2 = (message) => {
    setWaitForMessage(true)
    sendMessage(message)
  }

  const ImageSection = useMemo(() => {
    return (
      <div
        className={`auth_ai_message1 module ${isFadingOut ? 'fade-out' : 'fade-in'}`}
        id="messageWindow"
        ref={containerRef}
        style={{
          position: 'absolute',
          ...(imageUrl ? { backgroundImage: imageUrl } : { backgroundImage: 'none' }),
        }} 
      ></div>
    );
  }, [isFadingOut, imageUrl]);

  const iconButtonDown = useMemo(() => {
    return (
      <IconButton sx={{ position: 'absolute', zIndex: 1300, bottom: -2, right: 0}} onClick={ () => setDestination(Math.min(counter + 1, messages.length-1))}> 
        <Badge
          color="error"
          // variant="dot"
          // badgeContent={unreadedCount}
          // invisible={!showBadge}
          sx={{ [`& .${badgeClasses.badge}`]: { right: 5, top: 8 } }}
        >
          <TimelineDot color="primary" sx={{ margin: 0 }}>
            <ArrowDownwardIcon />
          </TimelineDot>
        </Badge>
      </IconButton>
    );
  }, [unreadedCount, messages.length, counter]);

  const goldMindMemo = useMemo(() => {
    return (
    <Snackbar
      anchorOrigin={{ vertical, horizontal }}
      open={open}
      key={vertical + horizontal}
    >
      <Alert
        onClose={handleClose}
        icon={<PsychologyAltIcon fontSize="inherit" />}
        severity="success"
        // variant="filled"
        sx={{ width: '100%' }}
      >
        {gold_mind}
      </Alert>
    </Snackbar> 
    );
  }, [open, gold_mind, vertical, horizontal]);

  const [addressBarVisible, setAddressBarVisible] = useState(false);
  const [ high, setHigh ] = useState(window.innerHeight);


  useEffect(() => {
    const checkAddressBar = () => {
      // Jeśli przeglądarka wspiera visualViewport, użyjemy go do odczytu wysokości widocznej przestrzeni.
      const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      
      // Przyjmujemy, że gdy wysokość viewportu jest mniejsza niż całkowita wysokość okna,
      // pasek adresu (lub inny element interfejsu) może być widoczny.
      // UWAGA: Ta logika jest heurystyczna i może wymagać dostosowania dla różnych przeglądarek.
      const isVisible = viewportHeight < window.innerHeight;
      if (window.innerHeight > high){
        setHigh(window.innerHeight)
      }
      if (window.innerHeight >= high){
        setFull('80vh')
        setAddressBarVisible('100vh');
      }else{
        setFull('80vh')
        setAddressBarVisible('90vh');
      }
      // setAddressBarVisible(window.innerHeight);
    };
    
    
    // Sprawdzamy na starcie
    checkAddressBar();

    // Nasłuchujemy zmiany rozmiaru widoku
    // window.addEventListener('resize', checkAddressBar);

    // // Sprzątamy przy odmontowaniu komponentu
    // return () => window.removeEventListener('resize', checkAddressBar);
  }, [window]);
  useEffect(() => {
    const checkAddressBar = () => {
      // Jeśli przeglądarka wspiera visualViewport, użyjemy go do odczytu wysokości widocznej przestrzeni.
      const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      
      // Przyjmujemy, że gdy wysokość viewportu jest mniejsza niż całkowita wysokość okna,
      // pasek adresu (lub inny element interfejsu) może być widoczny.
      // UWAGA: Ta logika jest heurystyczna i może wymagać dostosowania dla różnych przeglądarek.
      const isVisible = viewportHeight < window.innerHeight;
      if (window.innerHeight != high){
        if (window.innerHeight < high){
          setHigh(window.innerHeight)
        }else
        if (window.innerHeight <= high){
          setFull('83vh')
          setAddressBarVisible('100vh');
        }else{
          setFull('80vh')
          setAddressBarVisible('90vh');
        }
      }
      
      // setAddressBarVisible(window.innerHeight);
    };
    
    
    // Sprawdzamy na starcie
    checkAddressBar();

    // Nasłuchujemy zmiany rozmiaru widoku
    window.addEventListener('resize', checkAddressBar);

    // // Sprzątamy przy odmontowaniu komponentu
    return () => window.removeEventListener('resize', checkAddressBar);
  }, [window]);

  return (
      <Card 
      sx={{ 
        padding: 'unset',
        paddingLeft: '16px',
        paddingBottom: '16px',
        paddingRight: '16px',
        textAlign: 'center',
        width: {xs:'100vw', sm: '500px'}, 
        height: 'auto',
        minHeight: 'fit-content',
        }} 
        variant={'outlined'}>
          {/* blokada */}
          { !currentUser && messages.length !== 0 && messages.length >= 6 &&<Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            width: {xs:'100vw', sm: '500px'}, 
            height:'100vh',
            zIndex:'1301',
            position:'absolute',
            backgroundColor: '#101010',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            padding: '30px',
            opacity: currentUser? '0':'0.8'}}
          >
            <h2>Support our work</h2>
            <a href="https://buymeacoffee.com/mosaic.guardians" target="_blank" rel="noopener noreferrer">
              <Button
                type="button"
                size="large" 
                variant="contained"
                startIcon={<CoffeeIcon />}
              >
                Buy us a coffee
              </Button>
            </a>
            
              <Typography
                component="h2"
                variant="h6"
                sx={{ mt:5, padding: '10px', textAlign: 'center'  }}
              >
                To continue the conversation and maintain a history of our interactions, please log in. 😊
              </Typography>
              <Typography
                component="h2"
                variant="h6"
                sx={{  padding: '10px', textAlign: 'center',  }}
              >
                Additionally, by logging in, you gain access to many additional services. 🎉 
              </Typography>
              <Typography
                component="h2"
                variant="h6"
                sx={{  padding: '10px', textAlign: 'center', mb:1  }}
              >
                We encourage you to take advantage of this opportunity! 🌟
              </Typography>
              <Login />

              

              
          </Box>}
        
        
        <CardContent sx={{  
          // width: '100%',
          // top: '60px',
              // height: {xs:'100%', sm: 'fit-content'},
              display: 'flex',
              // marginTop: '60px',
              height: '100%',
              flexDirection: 'column',
              justifyContent: 'space-between'
        }}>
          <Typography
              component="h5"
              variant="h5"
              sx={{ fontWeight: '600',padding: '5px' }}
            >
              Sofia
              {/* <IconButton>
                <PlayArrowIcon />
              </IconButton> */}
        </Typography>
        <Box sx={{ width: 450 }}>
          {goldMindMemo}
        </Box>
            <div  style={{fontSize: _fontSize, color: 'black', textAlign: 'center', position: 'relative' }}>
                <IconButton sx={{ position: 'absolute', top: -2, right: 0, zIndex: 1300}} onClick={ () => setDestination(Math.max(counter - 1, 0))}> 
                  <TimelineDot color="primary" sx={{ margin: 0 }}>
                    <ArrowUpwardIcon />
                  </TimelineDot>
                </IconButton>
                <div className={`auth_ai_message2`} ></div>
                {ImageSection}
                <div
                    className={`auth_ai_message module`}
                    id="messageWindow"
                    ref={containerRef}
                    style={{
                      position: 'relative',
                    }}
                  >
                    <BasicTimeline messages={messages} />
                </div>
              <div>
              </div>
                {iconButtonDown}
            </div>

            {/* {isMobile ? <p>Jesteś na urządzeniu mobilnym.</p> : <p>Nie jesteś na urządzeniu mobilnym.</p>} */}
          
            <AuthInput mapData={mapData} sendMessage={sendMessage2} isTalking={isTalking} />
        </CardContent>
      </Card>
    );
}
